import { jsx as _jsx } from "react/jsx-runtime";
import { isEmptyArray } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useFilterOptions } from '../../../hooks/use-filter-options';
import { AccordionSection } from '../../../subcomponents/accordion/subcomponents/section';
import { FilterOptionList } from '../../../subcomponents/filter-option-list/filter-option-list';
const b = bemClassBuilder('v-composite-filter-accordion');
export const CompositeFilterAccordionSection = observer(props => {
    const { filterKey, isMultiselect } = props;
    const options = useFilterOptions(props.options, filterKey, !isMultiselect);
    if (isEmptyArray(options))
        return null;
    return (_jsx(AccordionSection, Object.assign({ id: filterKey, title: getSectionLabel(props.displayText, filterKey), expandedByDefault: props.expandedByDefault, className: b.element('section') }, { children: _jsx(FilterOptionList, { filterKey: filterKey, options: options, isMultiselect: isMultiselect, onChange: props.onChange, attributeIconCdnOptions: props.cdnOptions.attributeIcon }) })));
});
CompositeFilterAccordionSection.displayName = 'CompositeFilterAccordionSection';
const getSectionLabel = (displayText, filterKey) => {
    const labelsByFilterKey = {
        genre: displayText.genreFilterLabel,
        attribute: displayText.attributeFilterLabel,
        category: displayText.categoryFilterLabel,
        event: displayText.eventFilterLabel,
        subscription: displayText.subscriptionFilterLabel,
        billingPeriod: displayText.billingPeriodFilterLabel,
        billingRecurrence: displayText.billingRecurrenceFilterLabel
    };
    return labelsByFilterKey[filterKey];
};
